<template>
  <v-card class="mb-2">
    <div class="d-flex justify-space-between">
      <div>
        <v-card-title class="primary--text subtitle-1 mb-0 pb-0">
          Go to Job
        </v-card-title>
        <v-card-text>
          <span class="caption">
            Use this section to go straight to a specific job by entering the job's ID in the field below.
          </span>
          <v-form ref="navigateForm" class="d-flex mt-3" @submit.prevent>
            <v-text-field v-model="navigateJobId" class="job-id-input" label="Job ID" dense outlined :rules="[requiredRule]" @keyup.native.enter="jobIdNavigate()" />
            <v-btn depressed tile color="primary" class="ml-2" @click="jobIdNavigate()">
              Go to Job
            </v-btn>
          </v-form>
        </v-card-text>
      </div>
      <div v-if="isMigrationAgency" style="width: 50%;">
        <v-card-title class="primary--text subtitle-1 mb-0 pb-0">
          Create a new job
        </v-card-title>
        <v-card-text>
          <p class="caption mb-3">If you'd like to create a new job on behalf of one of your clients, use the button below.</p>
          <v-btn
            depressed
            tile
            color="success"
            to="jobs/create"
          >
            Create Job
            <v-icon class="ml-2">
              add
            </v-icon>
          </v-btn>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      navigateJobId: null
    }
  },
  computed: {
    requiredRule() {
      return val => !!val || 'Please enter a job ID'
    },
    isNumber() {
      return val => !Number.isNaN(+val) || 'Please enter a valid number'
    },
    isMigrationAgency () {
      return this.$store.getters['auth/isMigrationAgency']
    }
  },
  methods: {
    jobIdNavigate() {
      if (this.$refs.navigateForm.validate()) {
        this.$router.push(`/jobs/${this.navigateJobId}`)
      }
    }
  }
}
</script>
<style scoped>
  .job-id-input {
    max-width: 300px !important;
  }
</style>
